import React, { useEffect, useRef, useState } from "react";
import { Helmet } from "react-helmet";
import "./DigitalQualityAssurance.css";
import Testimonial from "../../../Testimonial/Testimonial";

const DigitalQualityAssurance = () => {
  const techItemsRow1 = [
    { name: "Angular.js", logo: "/logos/angular.png" },
    { name: "HTML", logo: "/logos/html.png" },
    { name: "CSS3", logo: "/logos/css.png" },
    { name: "Bootstrap", logo: "/logos/bootstrap.png" },
    { name: "Javascript", logo: "/logos/javascript.png" },
    { name: "AmazonDB", logo: "/logos/amazon_dynamodb.png" },
    { name: "Appian", logo: "/logos/appian.png" },
    { name: "Laravel", logo: "/logos/laravel.png" },
    { name: "MariaDB", logo: "/logos/mariadb.png" },
    { name: "MongoDB", logo: "/logos/mongodb.png" },
    { name: "Android", logo: "/logos/android-5.png" },
    { name: "ERC-20", logo: "/logos/erc-20.png" },
    { name: "Ethereum", logo: "/logos/ethereum.png" },
    { name: "Flutter", logo: "/logos/flutter.png" },
    { name: "Ionic", logo: "/logos/ionic.png" },
    { name: "Augmented Reality", logo: "/logos/Augmented Reality.png" },
    { name: "Crda", logo: "/logos/crda.png" },
    { name: "Data Science", logo: "/logos/data-science.png" },
    { name: "Go Chain", logo: "/logos/gochain.png" },
  ];

  const techItemsRow2 = [
    { name: "Sass", logo: "/logos/saas.png" },
    { name: "JQuery", logo: "/logos/jquery.png" },
    { name: "Less", logo: "/logos/less.png" },
    { name: "Codeigniter", logo: "/logos/codeignitor.png" },
    { name: "Django", logo: "/logos/django.png" },
    { name: "Node JS", logo: "/logos/node js.png" },
    { name: "PHP", logo: "/logos/php.png" },
    { name: "Salesforce", logo: "/logos/salesforce.png" },
    { name: "SQL Server", logo: "/logos/sql-server.png" },
    { name: "MySQL", logo: "/logos/mysql-5.png" },
    { name: "IOS", logo: "/logos/ios.png" },
    { name: "Oracle 6", logo: "/logos/oracle.png" },
    { name: "PostgreSQL", logo: "/logos/postgresql.png" },
    { name: "React Native", logo: "/logos/react_native.png" },
    { name: "Solidity", logo: "/logos/Solidity.png" },
    { name: "Hyperledger", logo: "/logos/Hyperledger.png" },
    { name: "Internet Of Things", logo: "/logos/iot.png" },
    { name: "One Ledger", logo: "/logos/OneLedger.png" },
    { name: "Virtual Reality", logo: "/logos/virtual-reality.png" },
  ];

  const duplicatedRow1 = [...techItemsRow1, ...techItemsRow1];
  const duplicatedRow2 = [...techItemsRow2, ...techItemsRow2];

  const containerRef = useRef(null);
  const row1Ref = useRef(null);
  const row2Ref = useRef(null);
  const [containerWidth, setContainerWidth] = useState(0);
  const [offset, setOffset] = useState(0);
  const animationRef = useRef();

  useEffect(() => {
    // Set initial container width
    if (containerRef.current) {
      setContainerWidth(containerRef.current.offsetWidth);
    }

    const handleResize = () => {
      if (containerRef.current) {
        setContainerWidth(containerRef.current.offsetWidth);
      }
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const scrollSpeed = 1; // Adjust speed as needed (pixels per frame)

    const animate = () => {
      setOffset((prevOffset) => {
        const maxOffset = row1Ref.current?.scrollWidth / 2 || 0;
        const newOffset = prevOffset + scrollSpeed;
        return newOffset >= maxOffset ? 0 : newOffset;
      });
      animationRef.current = requestAnimationFrame(animate);
    };

    animationRef.current = requestAnimationFrame(animate);

    return () => {
      cancelAnimationFrame(animationRef.current);
    };
  }, [containerWidth]);

    const [activeTab, setActiveTab] = useState('testing');

  const services = [
    {
      id: 'testing',
      title: 'Comprehensive Testing',
      description: 'Our rigorous testing methodologies ensure your digital products perform flawlessly across all platforms and devices.',
      icon: '🔍'
    },
    {
      id: 'automation',
      title: 'Test Automation',
      description: 'Streamline your testing process with our cutting-edge automation solutions that save time and reduce human error.',
      icon: '⚙️'
    },
    {
      id: 'security',
      title: 'Security Auditing',
      description: 'Protect your digital assets with our thorough security assessments and vulnerability testing.',
      icon: '🛡️'
    },
    {
      id: 'performance',
      title: 'Performance Optimization',
      description: 'Ensure your applications run smoothly under any load with our performance testing and optimization services.',
      icon: '🚀'
    }
  ];

  const caseStudies = [
    {
      title: 'E-commerce Platform Enhancement',
      result: '40% improvement in load time'
    },
    {
      title: 'Financial App Security Upgrade',
      result: '100% compliance with industry standards'
    },
    {
      title: 'Healthcare Portal Testing',
      result: '99.8% bug-free deployment'
    }
  ];

  return (
    <div>
      <Helmet>
        <title>Digital Quality Assurance | Comprehensive Testing Solutions</title>
        <meta 
          name="description" 
          content="Our digital quality assurance services ensure flawless software performance with cutting-edge testing methodologies and automation tools." 
        />
        <meta 
          name="keywords" 
          content="digital quality assurance, software testing, QA automation, performance testing, security testing, test automation, quality engineering, software quality" 
        />
      </Helmet>
      

    <div className="dq-assurance-page">
      {/* Hero Section */}
      <section className="dq-hero-section">
        <div className="dq-hero-content">
          <h1 className="dq-hero-title">Digital Quality Assurance</h1>
          <p className="dq-hero-subtitle">Ensuring excellence in every digital experience</p>
          <p className="dq-hero-description">
            At MK eTech, our Digital Quality Assurance services guarantee that your software 
            meets the highest standards of quality, security, and performance.
          </p>
         <a href="/contact-us"> <button className="dq-cta-button">Get Quality Assurance Audit</button></a>
        </div>
        <div className="dq-hero-visual">
          <div className="dq-visual-element dq-visual-1"></div>
          <div className="dq-visual-element dq-visual-2"></div>
          <div className="dq-visual-element dq-visual-3"></div>
        </div>
      </section>

      {/* Services Section */}
      <section className="dq-services-section">
        <h2 className="dq-section-title">Our QA Services</h2>
        <div className="dq-services-tabs">
          {services.map(service => (
            <div 
              key={service.id}
              className={`dq-service-tab ${activeTab === service.id ? 'dq-active-tab' : ''}`}
              onClick={() => setActiveTab(service.id)}
            >
              <span className="dq-service-icon">{service.icon}</span>
              <h3>{service.title}</h3>
            </div>
          ))}
        </div>
        <div className="dq-service-content">
          <div className={`dq-service-detail dq-${activeTab}-detail`}>
            <p>{services.find(s => s.id === activeTab).description}</p>
            <ul className="dq-service-features">
              {activeTab === 'testing' && (
                <>
                  <li>Functional Testing</li>
                  <li>Regression Testing</li>
                  <li>User Acceptance Testing</li>
                  <li>Cross-browser Compatibility</li>
                </>
              )}
              {activeTab === 'automation' && (
                <>
                  <li>CI/CD Integration</li>
                  <li>API Testing Automation</li>
                  <li>Visual Regression Testing</li>
                  <li>Custom Automation Frameworks</li>
                </>
              )}
              {activeTab === 'security' && (
                <>
                  <li>Penetration Testing</li>
                  <li>Vulnerability Assessment</li>
                  <li>Code Review</li>
                  <li>Security Compliance Testing</li>
                </>
              )}
              {activeTab === 'performance' && (
                <>
                  <li>Load Testing</li>
                  <li>Stress Testing</li>
                  <li>Speed Optimization</li>
                  <li>Scalability Assessment</li>
                </>
              )}
            </ul>
          </div>
        </div>
      </section>

      {/* Process Section */}
      <section className="dq-process-section">
        <h2 className="dq-section-title">Our Quality Assurance Process</h2>
        <div className="dq-process-steps">
          <div className="dq-process-step">
            <div className="dq-step-number">1</div>
            <h3>Requirement Analysis</h3>
            <p>We thoroughly analyze your requirements to develop a comprehensive testing strategy.</p>
          </div>
          <div className="dq-process-step">
            <div className="dq-step-number">2</div>
            <h3>Test Planning</h3>
            <p>Our experts create detailed test plans, cases, and scenarios tailored to your project.</p>
          </div>
          <div className="dq-process-step">
            <div className="dq-step-number">3</div>
            <h3>Execution & Reporting</h3>
            <p>We execute tests meticulously and provide detailed reports with actionable insights.</p>
          </div>
          <div className="dq-process-step">
            <div className="dq-step-number">4</div>
            <h3>Continuous Improvement</h3>
            <p>We help implement processes for ongoing quality enhancement throughout your SDLC.</p>
          </div>
        </div>
      </section>

      {/* Case Studies Section */}
      <section className="dq-cases-section">
        <h2 className="dq-section-title">Success Stories</h2>
        <div className="dq-case-studies">
          {caseStudies.map((caseStudy, index) => (
            <div key={index} className="dq-case-study">
              <h3>{caseStudy.title}</h3>
              <p>{caseStudy.result}</p>
              <div className="dq-case-hover-effect"></div>
            </div>
          ))}
        </div>
      </section>

      {/* CTA Section */}
      <section className="dq-cta-section">
        <h2>Ready to Ensure Your Digital Quality?</h2>
        <p>Contact us today for a comprehensive assessment of your digital products</p>
<a
  href="https://wa.me/919155599968?text=Hi!%20I%20am%20interested%20in%20Digital%20Quality%20Assurance%20services%20such%20as%20test%20automation%2C%20performance%20testing%2C%20and%20QA%20strategy.%20Please%20schedule%20a%20consultation."
  target="_blank"
  rel="noreferrer"
>
  <button className="dq-cta-button">Schedule a Consultation</button>
</a>

      </section>
    </div>

      <Testimonial />

      <div className="tech-slider-container" ref={containerRef}>
        <h2 className="tech-slider-title">Tools & Tech Stack</h2>
        <div className="tech-slider-divider"></div>

        {/* First row */}
        <div className="tech-slider-wrapper">
          <div
            className="tech-slider-row"
            ref={row1Ref}
            style={{ transform: `translateX(-${offset}px)` }}
          >
            {duplicatedRow1.map((tech, index) => (
              <div key={`row1-${index}`} className="tech-slide">
                <img
                  src={tech.logo}
                  alt={tech.name}
                  className="tech-logo"
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = "/logos/default.png";
                  }}
                />
                <span className="tech-name">{tech.name}</span>
              </div>
            ))}
          </div>
        </div>

        {/* Second row */}
        <div className="tech-slider-wrapper">
          <div
            className="tech-slider-row"
            ref={row2Ref}
            style={{ transform: `translateX(-${offset}px)` }}
          >
            {duplicatedRow2.map((tech, index) => (
              <div key={`row2-${index}`} className="tech-slide">
                <img
                  src={tech.logo}
                  alt={tech.name}
                  className="tech-logo"
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = "/logos/default.png";
                  }}
                />
                <span className="tech-name">{tech.name}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default DigitalQualityAssurance;